import React, { useState } from 'react';
import { Html } from '@react-three/drei';

const FACILITY_COLORS = {
  toilet: '#06b6d4',
  toilet_vvip: '#a855f7',
  prayer_room: '#16a34a',
  first_aid: '#dc2626',
  parking: '#3b82f6',
  entrance: '#eab308',
  info: '#8b5cf6',
  food: '#f97316',
};

/**
 * 3D icon markers for toilets, prayer rooms, food, parking, entrances, etc.
 * A short vertical post + coloured icon plate + hover label.
 */
export function FacilityMarker({ facility }) {
  const [hovered, setHovered] = useState(false);
  const color = FACILITY_COLORS[facility.type] || '#64748b';

  return (
    <group
      position={[facility.position_x, 0, facility.position_z]}
      onPointerOver={(e) => { e.stopPropagation(); setHovered(true); document.body.style.cursor = 'pointer'; }}
      onPointerOut={() => { setHovered(false); document.body.style.cursor = 'auto'; }}
    >
      <mesh position={[0, 0.05, 0]} rotation={[-Math.PI / 2, 0, 0]}>
        <cylinderGeometry args={[1.2, 1.2, 0.1, 16]} />
        <meshStandardMaterial color={color} emissive={color} emissiveIntensity={hovered ? 0.6 : 0.3} />
      </mesh>

      <mesh position={[0, 1.5, 0]} castShadow>
        <cylinderGeometry args={[0.08, 0.08, 3, 6]} />
        <meshStandardMaterial color="#4a4a4a" metalness={0.6} />
      </mesh>

      <mesh position={[0, 3.2, 0]} castShadow>
        <boxGeometry args={[1.5, 1.5, 0.15]} />
        <meshStandardMaterial color={color} emissive={color} emissiveIntensity={hovered ? 0.5 : 0.2} />
      </mesh>

      <Html zIndexRange={[10, 0]} position={[0, 3.2, 0.15]} center distanceFactor={20}>
        <div
          className="text-3xl pointer-events-none select-none"
          style={{
            filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))',
            transform: `scale(${hovered ? 1.3 : 1})`,
            transition: 'transform 0.2s',
          }}
        >
          {facility.icon || '📍'}
        </div>
      </Html>

      {hovered && (
        <Html zIndexRange={[10, 0]} position={[0, 4.5, 0]} center>
          <div className="bg-slate-900/95 backdrop-blur-sm px-2 py-1 rounded shadow-xl border border-slate-700 whitespace-nowrap pointer-events-none">
            <div className="text-white text-xs font-semibold">{facility.name}</div>
          </div>
        </Html>
      )}
    </group>
  );
}
